export default "__VITE_ASSET__DC5EdEt8__"